export const ENDPOINTS = {
  get_resources: "resources/",
};